/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

// Intercept your existing inline onclick openTab function
const originalOpenTab = window.openTab;

window.openTab = function(evt, tabName) {
  // 1. Execute your core tab switching logic first (shows the panel)
  if (typeof originalOpenTab === 'function') {
    originalOpenTab(evt, tabName);
  }

  // 2. Allow a tiny split-second delay for the display state to change
  setTimeout(() => {
    // Find the clicked tab element by its ID (e.g., 'Youtube', 'Linus')
    const activeTab = document.getElementById(tabName);
    
    if (activeTab) {
      const iframe = activeTab.querySelector('iframe');
      
      // Only run the refresh fix if the iframe exists and has a source
      if (iframe && iframe.src) {
        const currentSrc = iframe.src;

        // Step A: Immediately hide the player via opacity to prevent a white flash
        iframe.classList.add('refreshing');

        // Step B: Reset the source to recalculate container dimensions
        setTimeout(() => {
          iframe.src = '';
          iframe.src = currentSrc;

          // Step C: Seamlessly fade back in only when YouTube finishes loading
          iframe.onload = function() {
            iframe.classList.remove('refreshing');
          };
        }, 150); // Short delay ensures the browser registers the hidden-to-visible flip
      }
    }
  }, 30);
};